export const config = {
  BASE_API: import.meta.env.VITE_BASE_API,
  SOCKET_BASE_URL: import.meta.env.VITE_SOCKET_BASE_API,
};
